import { render, staticRenderFns } from "./AdminPrivilegeList.vue?vue&type=template&id=83d847a0&scoped=true&"
import script from "./AdminPrivilegeList.vue?vue&type=script&lang=js&"
export * from "./AdminPrivilegeList.vue?vue&type=script&lang=js&"
import style0 from "./AdminPrivilegeList.vue?vue&type=style&index=0&id=83d847a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d847a0",
  null
  
)

export default component.exports